import React, { CSSProperties, Fragment, useCallback, useEffect, useMemo, useState } from 'react'
import { Button, Card, Col, Form, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from 'react-bootstrap';
import { ResultOperation, Column, SelfTableList, FilterState, ListFields, usePermission, useTranslation, useFetch } from '@np/np_webcomponentlib'
import { API_BUSINESS, API_OPERATIONS_VIEW } from '../../shared/consts/api'


import { ColumnEvent, ColumnWithCopyToClipboard, ColumnData } from '../../shared/entityOperations/EntityOperationsCustomFC'
import TypeOperationCheckboxList from '../../shared/MasterData/TypeOperationCheckboxList';

import {DataEntityType as BusinessType} from '../Business/BusinessTypes'
import { useNavigate } from 'react-router-dom';
import { formatAmount } from '../../shared/utils/formatAmount';
import { TypeOperationEnum } from '../../shared/MasterData/MasterDataTypes';


interface EntityData {
  business: BusinessType;
  sumAmountOperation: number;
  sumAmountBalanceCurrency: number;
  sumComissionInBalanceCurrency: number;
  sumComissionProviderInBalanceCurrency: number;
  marjaBalanceCurrency: number;
  percentMarjaCommision: number;
  percentMarjaTotal: number;
  amountExhcngeRareDiff: number;
  marjaTotal: number
}


    

const DashboardMarja = ({title }: { title: string }) => {

  const [entity, setEntity] = useState<EntityData[]>([])

  const [entityProviders, setEntityProviders] = useState<EntityData[]>([])

  const [startDate, setStartDate] = useState<Date>(new Date())
  const [endDate, setEndDate] = useState<Date>(new Date())
  

  const [selectedTypeOperations, setSelectedTypeOperations] = useState<TypeOperationEnum[]>([TypeOperationEnum.PayIn, TypeOperationEnum.PayOut]);


  const [, doFetchLoad] = useFetch(
    `${API_OPERATIONS_VIEW}dashboard/marja/merchant`)//{ error: errCU, isLoading: isLoadCU, response: respCU }

  const [, doFetchLoadProviders] = useFetch(
      `${API_OPERATIONS_VIEW}dashboard/marja/provider`)//{ error: errCU, isLoading: isLoadCU, response: respCU }

    
  useEffect(() => {

    doFetchLoad({
        method: 'POST',
        headers: { "Content-Type": "application/json" },
        data: {
          startDate: startDate,
          endDate: endDate,
          listTypeOperation: selectedTypeOperations
      }
    }).then(responce => {
      setEntity(responce.dataList)
      console.log(responce.dataList)
  })


  doFetchLoadProviders({
      method: 'POST',
      headers: { "Content-Type": "application/json" },
      data: {
        startDate: startDate,
        endDate: endDate,
        listTypeOperation: selectedTypeOperations
    }
  }).then(responce => {
    setEntityProviders(responce.dataList)
  })

    

}, [startDate, endDate, selectedTypeOperations])

  // Calculate total values for the summary row
  const totals = useMemo(() => {
    return entity.reduce(
      (acc, item) => {
        acc.marjaBalanceCurrency += item.marjaBalanceCurrency;
        acc.amountExhcngeRareDiff += item.amountExhcngeRareDiff;
        acc.sumAmountOperation += item.sumAmountOperation;
        acc.sumAmountBalanceCurrency += item.sumAmountBalanceCurrency;
        acc.sumComissionInBalanceCurrency += item.sumComissionInBalanceCurrency;
        acc.sumComissionProviderInBalanceCurrency += item.sumComissionProviderInBalanceCurrency;
        return acc;
      },
      {
        marjaBalanceCurrency: 0,
        amountExhcngeRareDiff:0,
        sumAmountOperation: 0,
        sumAmountBalanceCurrency: 0,
        sumComissionInBalanceCurrency: 0,
        sumComissionProviderInBalanceCurrency: 0,
      }
    );
  }, [entity]);

  const totalsProviders = useMemo(() => {
    return entityProviders.reduce(
      (acc, item) => {
        acc.marjaBalanceCurrency += item.marjaBalanceCurrency;
        acc.amountExhcngeRareDiff += item.amountExhcngeRareDiff;
        acc.sumAmountOperation += item.sumAmountOperation;
        acc.sumAmountBalanceCurrency += item.sumAmountBalanceCurrency;
        acc.sumComissionInBalanceCurrency += item.sumComissionInBalanceCurrency;
        acc.sumComissionProviderInBalanceCurrency += item.sumComissionProviderInBalanceCurrency;
        return acc;
      },
      {
        marjaBalanceCurrency: 0,
        amountExhcngeRareDiff:0,
        sumAmountOperation: 0,
        sumAmountBalanceCurrency: 0,
        sumComissionInBalanceCurrency: 0,
        sumComissionProviderInBalanceCurrency: 0,
      }
    );
  }, [entityProviders]);


  return (
    <Fragment>

      <h2>{title}</h2>

      <Card>
    <Card.Header>
        <Card.Title as='h4'>{useTranslation('generateReport')}</Card.Title>
    </Card.Header>
    <Card.Body className="">
        {/* <Form className="form-horizontal"> */}

        <Col md={6}>
                <Form.Label className="col-md-3">{useTranslation('startDate')}</Form.Label>
                <Col md={9}>
                <Form.Control 
                    type="date" 
                    placeholder={useTranslation('startDate')} 
                    value={startDate ? startDate.toISOString().split('T')[0] : ''} 
                    onChange={e => setStartDate(new Date(e.target.value))} // Преобразуем строку в объект Date
                />
                </Col>
            </Col>

            <Col md={6}>
                <Form.Label className="col-md-3">{useTranslation('endDate')}</Form.Label>
                <Col md={9}>
                <Form.Control 
                    type="date" 
                    placeholder={useTranslation('endDate')} 
                    value={endDate ? endDate.toISOString().split('T')[0] : ''} 
                    onChange={e => setEndDate(new Date(e.target.value))} // Преобразуем строку в объект Date
                />
                </Col>
                </Col>

    
                </Card.Body>
                </Card>

      <TypeOperationCheckboxList
                selectedOperations={selectedTypeOperations}
                onChange={setSelectedTypeOperations}
            />

      <h2 style={{ marginTop: "50px", marginBottom: "50px" }}>Мерчанты</h2>
      
      <TableData titleFirstColumn="Мерчант" entity={entity} totals={totals}></TableData>

      <h2 style={{ marginTop: "50px", marginBottom: "50px" }}>Провайдеры</h2>

      <TableData titleFirstColumn="Провайдер" entity={entityProviders} totals={totalsProviders}></TableData>
      
    </Fragment>
  )
}

export default DashboardMarja

const TableData = ({titleFirstColumn, entity, totals}:{titleFirstColumn: string, entity: EntityData[], totals: { marjaBalanceCurrency: number; amountExhcngeRareDiff: number; sumAmountOperation: number; sumAmountBalanceCurrency: number; sumComissionInBalanceCurrency: number; sumComissionProviderInBalanceCurrency: number; }}) => {
  const navigate = useNavigate()
  
  const fixedColumnStyle: CSSProperties = {
    width: "300px",
    whiteSpace: "normal",
    wordWrap: "break-word",
    wordBreak: "break-word",
    textAlign: "center"
  };
  
  return <table className="table table-bordered text-nowrap mb-0">

    <thead>
      <tr>
        <th style={fixedColumnStyle}>
          {titleFirstColumn}
        </th>
        <th>Маржа</th>
        <th>Схлоп</th>
        <th>% Маржи</th>


        <th>
          Сумма (опер.)
        </th>

        <th>Сумма(бал.)</th>
        <th>Комиссия</th>
        <th>Комиссия провайдера</th>

      </tr>
    </thead>

    <tbody>
      {entity && entity.length > 0 ? (
        entity.map((item, index) => (
          <tr key={index}>
            <td style={fixedColumnStyle}><div onClick={() => navigate("/business/" + item.business.idUnique)}>
          {item.business?.name}
        </div></td>
            <td>{formatAmount(item.marjaBalanceCurrency)}/{formatAmount(item.marjaTotal)}</td>
            <td>{formatAmount(item.amountExhcngeRareDiff, 4)}</td>
            <td>{formatAmount(item.percentMarjaCommision)}/{formatAmount(item.percentMarjaTotal)}</td>




            <td>{formatAmount(item.sumAmountOperation, 0)}</td>
            <td>{formatAmount(item.sumAmountBalanceCurrency, 0)}</td>
            <td>{formatAmount(item.sumComissionInBalanceCurrency, 0)}</td>
            <td>{formatAmount(item.sumComissionProviderInBalanceCurrency, 0)}</td>





          </tr>
        ))
      ) : (
        <tr>
          <td colSpan={7} className="text-center">
            Данные не найдены
          </td>
        </tr>
      )}


      {/* Summary Row */}
      {entity && entity.length > 0 && (
        <tr>
          <td><strong>Итого</strong></td>
          <td><strong>{formatAmount(totals.marjaBalanceCurrency)}</strong></td>
          <td><strong>{formatAmount(totals.amountExhcngeRareDiff)}</strong></td>
          <td><strong>{formatAmount(((totals.sumComissionInBalanceCurrency - totals.sumComissionProviderInBalanceCurrency) / totals.sumAmountBalanceCurrency) * 100)}</strong>/
          {formatAmount(((totals.marjaBalanceCurrency + totals.amountExhcngeRareDiff)/totals.sumAmountBalanceCurrency)*100)}</td>
          <td><strong>{formatAmount(totals.sumAmountOperation, 0)}</strong></td>
          <td><strong>{formatAmount(totals.sumAmountBalanceCurrency, 0)}</strong></td>
          <td><strong>{formatAmount(totals.sumComissionInBalanceCurrency, 2)}</strong></td>
          <td><strong>{formatAmount(totals.sumComissionProviderInBalanceCurrency, 2)}</strong></td>
        </tr>
      )}
    </tbody>

  </table>;
}
